import { useMediaQuery, useTheme as useMuiTheme } from '@mui/material';

export const useIsMobile = () => {
	const muiTheme = useMuiTheme();
	const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

	return isMobile;
};
